export function publicationDateLabel(story) {
  const date = new Date(story?.dateIso || '');
  if (!Number.isFinite(date.getTime())) return story?.date || '';
  const clock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Africa/Banjul', hour: 'numeric', minute: '2-digit', hour12: true,
  }).format(date).replace(/am|pm/gi, part => part.toUpperCase());
  return `${story.date}, ${clock} GMT`;
}
